/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SrsTriggerDataCollectionModel } from '../../models/srs-trigger-data-collection-model';

export interface PmsrsTriggerDataCollection$Params {
  systemSerialNumber: string;
  systemMaterialNumber: number;
  systemSoftwareVersion: string;
}

export function pmsrsTriggerDataCollection(http: HttpClient, rootUrl: string, params: PmsrsTriggerDataCollection$Params, context?: HttpContext): Observable<StrictHttpResponse<SrsTriggerDataCollectionModel>> {
  const rb = new RequestBuilder(rootUrl, pmsrsTriggerDataCollection.PATH, 'get');
  if (params) {
    rb.path('systemSerialNumber', params.systemSerialNumber, {});
    rb.path('systemMaterialNumber', params.systemMaterialNumber, {});
    rb.path('systemSoftwareVersion', params.systemSoftwareVersion, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SrsTriggerDataCollectionModel>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
pmsrsTriggerDataCollection.PATH = '/api/PatternMatch/srstriggerdatacollection/{systemSerialNumber}/{systemMaterialNumber}/{systemSoftwareVersion}';
pmsrsTriggerDataCollection.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
pmsrsTriggerDataCollection.ROOTURL = '/patternmatch';
